import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import NotFoundPage from "./components/NotFoundPage/NotFoundPage";
import Auth from "./containers/Auth/Auth";
import Application from "./containers/Auth/Application";
import ForgetLogin from "./containers/Auth/ForgetLogin";
import Recovery from "./containers/Auth/Recovery";

import Dashboard from "./containers/Dashboard/Dashboard";

class App extends Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Application />} />
            <Route path="/admin" element={<Auth />} />
            <Route path="/forgetlogin" element={<ForgetLogin />} />
            <Route path="/recovery" element={<Recovery />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
